import { useQuery } from '@tanstack/react-query';

import {
  type ListVoucherAutoAssignmentRuleAssignmentGroupsResponse,
  listVoucherAutoAssignmentRuleAssignmentGroups,
} from '~/services/PromoService';

import { voucherAutoAssignmentRuleQueryKeys } from './voucherAutoAssignmentRuleQueryKeys';

type Params = {
  query?: Parameters<typeof listVoucherAutoAssignmentRuleAssignmentGroups>[0];
  enabled?: boolean;
};

export function useListVoucherAutoAssignmentRuleAssignmentGroups({ query = {}, enabled = true }: Params = {}) {
  return useQuery<ListVoucherAutoAssignmentRuleAssignmentGroupsResponse>({
    queryKey: voucherAutoAssignmentRuleQueryKeys.assignmentGroups(query),
    queryFn: async ({ signal }) => listVoucherAutoAssignmentRuleAssignmentGroups(query, { signal }),
    enabled,
  });
}
